<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span>{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    Bulk Photo Upload
                </v-toolbar-title>
            </v-toolbar>

            <v-row justify="center" align="center" class="mt-8">
                <v-col cols="12" sm="6" class="d-flex justify-center">
                    <v-file-input
                        v-model="file"
                        label="Select ZIP File"
                        accept=".zip"
                        prepend-icon="mdi-folder-zip"
                        style="max-width: 350px;"
                        show-size
                        outlined
                        dense
                        rounded
                    />
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-btn color="primary" :loading="dialog_upload" @click="uploadZipPhotos" rounded>
                    Submit
                </v-btn>
            </v-row>

        </v-card>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            file: null,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            dialog_upload: false,
        };
    },
    mounted() {
        this.basepath = localStorage.getItem("awspath");
    },
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        uploadZipPhotos() {

            if (!this.file) {
                this.showSnackbar("#b71c1c", "Please select ZIP file");
                return;
            }

            if (!this.file.name.toLowerCase().endsWith(".zip")) {
                this.showSnackbar("#b71c1c", "Only ZIP file allowed");
                return;
            }

            let formData = new FormData();
            formData.append("file", this.file);

            this.dialog_upload = true;

            axios
                .post("/Admission/saveStudentPhotosFromZip", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    if (res.data.status === "YES") {
                        this.showSnackbar("#4caf50", "Upload Completed");
                        this.file = null;
                    } else if (res.data.status === "NO"){
                        this.showSnackbar("#b71c1c", "No learner found");
                        this.file = null;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.message || "Upload failed");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                })
                .finally(() => {
                    this.dialog_upload = false;
                });
        },
    }
};
</script>
<style scoped>
</style>